import React, { useCallback, useEffect, useState } from 'react';
import { GoogleMap, LoadScript } from "@react-google-maps/api";
import mapStyles from "../../../src/styles/map_styles.json";
import ClusterWrap from "./ClusterWrap";

import './index.sass';


const containerStyle = {
  width: "100%",
  height: "100%",
};


const MapWrapper = ({ boundsTrigger,
                      coords,
                      googleApiKey,
                      hoveredPlaceId,
                      isSuccess,
                      markers,
                      markersLoading,
                      setBoundsTrigger,
                      setCoords,
                      setPage,
                      setRequestError,
                      updateUrlParameters }) => {

  const [googleMap, setGoogleMap] = useState(null);
  const [mapLoaded, setMapLoaded] = useState(false);
  const [mapDragged, setMapDragged] = useState(null);
  const [mapZoomed, setMapZoomed] = useState(null);
  const [mapBounds, setMapBounds] = useState(false);


  useEffect(() => {
    boundsTrigger && boundsMap();
  }, [boundsTrigger]);


  useEffect(() => {
    (!coords || !Object.keys(coords).length) && mapLoaded && setMapLoaded(false);
  }, [coords]);


  const onLoad = useCallback((map) => {
    setGoogleMap(map);
    markers && markers.length && boundsMap(map);
  },[]);


  const onDragEnd = (changeCoords, boundsTrigger) => {
    boundsTrigger && setBoundsTrigger(false);
    setMapDragged(false);
    setMapZoomed(false);

    if (googleMap && mapLoaded && changeCoords && !boundsTrigger && !mapBounds) {
      const ne = googleMap.getBounds().getNorthEast();
      const sw  = googleMap.getBounds().getSouthWest();
      const coords = {
        sw_corner_latitude: sw.lat(),
        sw_corner_longitude: sw.lng(),
        ne_corner_latitude: ne.lat(),
        ne_corner_longitude: ne.lng(),
      };

      setPage(1);
      setCoords(coords);
      updateUrlParameters({ page: '' });
    };

    setMapBounds(false);
  };


  const boundsMap = (map) => {
    const currentMap = map || googleMap;
    const markersArray = markers && markers.length && markers.map(elem => elem.attributes).filter(marker => !!(marker.lat && marker.long));

    if (currentMap && markersArray.length > 0) {
      const bounds = new window.google.maps.LatLngBounds();

      setMapBounds(true);

      markersArray.map((elem) => {
        elem.lat && elem.long && bounds.extend(new window.google.maps.LatLng(elem.lat, elem.long));
        return elem;
      });

      if (bounds.getNorthEast().equals(bounds.getSouthWest())) {
        const extendPoint1 = new window.google.maps.LatLng(bounds.getNorthEast().lat() + 0.001,
          bounds.getNorthEast().lng() + 0.001);
        const extendPoint2 = new window.google.maps.LatLng(bounds.getNorthEast().lat() - 0.001,
          bounds.getNorthEast().lng() - 0.001);

        bounds.extend(extendPoint1);
        bounds.extend(extendPoint2);
      }

      currentMap.fitBounds(bounds);
    };
  };

  const updateTrigger = mapDragged || mapZoomed;


  return (
    <div className="map-section__map-wrapper">
      <LoadScript googleMapsApiKey={googleApiKey}>
        <GoogleMap
          mapContainerStyle={containerStyle}
          mapContainerClassName="main-map"
          id="main-map"
          zoom={6}
          onDragStart={() => setMapDragged(true)}
          onZoomChanged={() => setMapZoomed(true)}
          onIdle={() => onDragEnd(updateTrigger, boundsTrigger)}
          onBoundsChanged={() => !mapLoaded && setMapLoaded(true)}
          options={{
            gestureHandling: "greedy",
            styles: mapStyles,
            scrollwheel: true,
            mapTypeControl: false,
            fullscreenControl: false,
            panControl: false,
            streetViewControl: false,
          }}
          onLoad={onLoad}
        >
          <ClusterWrap
            boundsTrigger={boundsTrigger}
            closeInfoWindow={mapDragged || mapZoomed || boundsTrigger}
            hoveredPlaceId={hoveredPlaceId}
            isSuccess={isSuccess}
            markers={markers}
            markersLoading={markersLoading}
            setRequestError={setRequestError}
          />
        </GoogleMap>
      </LoadScript>
    </div>
  )
}

export default MapWrapper;
